import image from './images/access-denied.svg';
import ErrorPageLayout from 'pages/Error/ErrorPageLayout';
import { useTranslation } from 'react-i18next';

const AccessDenied = () => {
    const { t } = useTranslation();

    return (
        <ErrorPageLayout
            description={t(
                'common:errors.access-denied-description',
                'Your current account or role doesn’t have permission to view this page. Please contact your administrator to request access, or switch to an account with the appropriate permissions.'
            )}
            image={image}
            imageAlt={t('common:errors.access-denied-illustration', 'Access denied illustration')}
            imageHeight={186}
            imageWidth={404}
            title={t('common:errors.access-denied-title', 'You Don’t Have Access to This Page')}
        />
    );
};

export default AccessDenied;
